const url = process.env.REACT_APP_API_URL

export {url}